import { UserRoles } from "data/roles";

export const userDefault = Object.freeze({
  characterIds: [],
  credits: 10,
  favorites: [],
  role: UserRoles.USER,
  storyIds: [],
});
